import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import { convertToTitleCase } from "../../../../../../../../config/config";
import { getCreatedOnMesage } from "../../helper/helper";
import ListTile from "../../../../../../../../modules/molecules/ListTile/main";
import AvatarListShimmer from "../../../../../../../../modules/molecules/shimmer/List/main";
import { WrapperType } from "./wrapper.type";
import CustomCard from "../../../../../../../../modules/atoms/cards/main";
import Icon from "../../../../../../../../icons/main";
import dayjs from "dayjs";
import { memo } from "react";
import { activityItemType } from "../../activity.types";
const Wrapper = ({
  farmActivityLoading,
  farmActivityFetching,
  farmerActivityLoading,
  farmerActivityFetching,
  cropActivityLoading,
  cropActivityFetching,
  farmActivityError,
  farmerActivityError,
  cropActivityError,
  refetchHandler,
  farmListData,
  farmerListData,
  cropListData,
}: WrapperType) => {
  if (
    farmActivityError ||
    farmerActivityError ||
    (cropActivityError &&
      !farmActivityFetching &&
      !cropActivityFetching &&
      !farmerActivityFetching)
  ) {
    return (
      <Grid item container alignContent={"flex-start"}>
        <Grid item xs={12}>
          <Typography
            variant="subtitle1"
            sx={{ marginLeft: "1.625rem", fontSize: "0.875rem" }}
            data-testid="activity-heading"
          >
            Recent Activities
          </Typography>
        </Grid>
        <Grid item xs={12} data-testid="onerror-loader">
          <CustomCard
            style={{
              positon: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "195.297px",
              height: "200px",
              backgroundColor: "rgba(0, 0, 0, 0.11)",
              borderRadius: "1rem",
              marginLeft: "5px",
            }}
          >
            {Icon["refresh"](refetchHandler)}
          </CustomCard>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid item container alignContent={"flex-start"}>
      <Grid item xs={12}>
        <Typography
          variant="subtitle1"
          sx={{ marginLeft: "1.625rem", fontSize: "0.875rem" }}
          data-testid="activity-heading"
        >
          Recent Activities
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          maxHeight: "50vh",
          overflowY: "scroll",
        }}
        id="activity-scroll-container"
      >
        {farmActivityLoading ||
        farmActivityFetching ||
        farmerActivityLoading ||
        farmerActivityFetching ||
        cropActivityLoading ||
        cropActivityFetching ? (
          <AvatarListShimmer
            avatarVarient="rectangular"
            avatarStyle={{ borderRadius: "8px" }}
            enableSubtitle={true}
          />
        ) : [...farmListData, ...farmerListData, ...cropListData].length ===
          0 ? (
          <Typography
            variant="subtitle2"
            sx={{ marginLeft: "1.625rem" }}
            data-testid="empty-activity"
          >
            No Recent activity
          </Typography>
        ) : (
          <List
            sx={{
              width: "100%",
              maxWidth: 360,
              bgcolor: "background.paper",
            }}
            data-testid="activity-list"
          >
            {[...farmListData, ...farmerListData, ...cropListData].length > 0 &&
              [...farmListData, ...farmerListData, ...cropListData]
                .slice(0, 100)
                .sort((a, b) =>
                  dayjs(b.date_time).diff(dayjs(a.date_time), "hour"),
                )
                .map((e: activityItemType) => {
                  return (
                    <ListTile
                      title={
                        (e.created_by?.trim() !== ""
                          ? convertToTitleCase(e.created_by.trim())
                          : "") +
                        "-" +
                        e.farmer_block?.toLowerCase()
                      }
                      subtitle={getCreatedOnMesage(e.date_time)}
                      avatarType="icon"
                      iconSrc={
                        e.type === "farm"
                          ? "farmIcon"
                          : e.type === "crop"
                          ? "cropIcon"
                          : "farmerIcon"
                      }
                      alignItems="center"
                      key={e.id + (e.type as "farm" | "farmer" | "crop")}
                      avatarBackgroundColor={
                        e.type === "farm"
                          ? "#D9F2DA"
                          : e.type === "crop"
                          ? "#D9F2DA"
                          : "#F9E8C9"
                      }
                    />
                  );
                })}
          </List>
        )}
      </Grid>
    </Grid>
  );
};

export default memo(Wrapper);
